'use client'
import { useEffect } from 'react'

export const PAGE_HIDDEN_TITLE = 'Ei, psiu, volte aqui!'

/**
 * Troca o título da aba por "Ei, psiu, volte aqui!" enquanto a aba está escondida e devolve o título da página quando
 * ela volta (se a página não trocou de título no meio). Montado uma vez no ClientShell, no lugar das cópias de
 * `visibilitychange` que havia nos layouts.
 */
export function usePageVisibilityTitle(hiddenTitle: string = PAGE_HIDDEN_TITLE) {
    useEffect(() => {
        let pageTitle = document.title

        const handleVisibilityChange = () => {
            if (document.hidden) {
                pageTitle = document.title
                document.title = hiddenTitle
            } else if (document.title === hiddenTitle) {
                document.title = pageTitle
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
    }, [hiddenTitle])
}
